export default __webpack_public_path__ + "static/media/Agustina.eb0c59dd.woff";